import { PropertyFormatIdentifier } from "../../../../constants/propertyFormats";
import { definitionActionTypes } from "../../../definition";
import { propertyActionTypes } from "../../../definition/properties";
import { actionTypes as itemActionTypes } from "../../../items/actions";
import rootActionTypes from "../../../rootActionTypes";
import { getAffectedActionIds } from "./getIdsFromActions";

const individualActionTypes = [
  //#!if readonly !== true
// itemActionTypes.SET_PROPERTY_VALUE,
// itemActionTypes.AUTO_MATCH_FILTERS
  //#!endif
];

const globalActionTypes = [
  //#!if readonly !== true
// propertyActionTypes.TOGGLE_INDICATE_ITEM_COMPLETION,
  //#!endif
  definitionActionTypes.REPLACE_DEFINITIONS,
  rootActionTypes.LOAD_FILE,
  rootActionTypes.UPDATE_FILE,
  rootActionTypes.LOAD_SAMPLE
];

export const getIsCompleted = (item, propertiesById) => {
  return (
    item.propertyValues.find((propValue, propId) => {
      const property = propertiesById.get(propId);
      return (
        property &&
        property.indicateItemCompletion &&
        ((property.format === PropertyFormatIdentifier.boolean && propValue === true) ||
          (property.format === PropertyFormatIdentifier.percentage && propValue >= 100))
      );
    }) !== undefined
  );
};

// Changes:
//  - initials
const updateItemComplete = (state, action, newItemsById, newPropertiesById) => {
  // Because we merge ItemRecord into ItemDisplayRecord for all changed items,
  // and ItemRecord has a field called "initials" that might be null,
  // we need to set the initials again for every single item that has changed
  // because its old default value will have been replaced by the null

  const { affectedIds } = getAffectedActionIds(state, action, globalActionTypes, individualActionTypes);

  if (!affectedIds.length) {
    return state;
  }

  return state.withMutations(s => {
    affectedIds.forEach(cId => {
      const item = newItemsById.get(cId);
      const itemRec = state.get(cId);
      const isCompleted = getIsCompleted(item, newPropertiesById);
      if (isCompleted !== itemRec.isCompleted) {
        s.update(cId, d => d.set("isCompleted", isCompleted));
      }
    });
  });
};

export default updateItemComplete;
